document.addEventListener("DOMContentLoaded", () => {
  let lenis;

  const initSmoothScrolling = () => {
    lenis = new Lenis({
      lerp: 0.05, // Lower values create a smoother scroll effect
      smoothWheel: true,
    });

    lenis.on("scroll", () => ScrollTrigger.update());
    const scrollFn = (time) => {
      lenis.raf(time);
      requestAnimationFrame(scrollFn);
    };
    requestAnimationFrame(scrollFn);
  };

  // Initialize smooth scrolling for desktop
  if (window.innerWidth > 768) {
    initSmoothScrolling();
  }

  // Create scroll lock utilities and expose them globally
  window.scrollLock = {
    disable: function() {
      // Stop Lenis if it's initialized
      if (lenis) {
        lenis.stop();
      }
      
      // Use body-scroll-lock if available
      if (window.bodyScrollLock && window.bodyScrollLock.disableBodyScroll) {
        window.bodyScrollLock.disableBodyScroll(document.body);
      } else {
        // Fallback method if bodyScrollLock isn't available
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
      }
    },
    
    enable: function() {
      // Restart Lenis if it's initialized
      if (lenis) {
        lenis.start();
      }
      
      // Use body-scroll-lock if available
      if (window.bodyScrollLock && window.bodyScrollLock.enableBodyScroll) {
        window.bodyScrollLock.enableBodyScroll(document.body);
      } else {
        // Fallback method if bodyScrollLock isn't available
        document.body.style.overflow = '';
        document.body.style.height = '';
      }
    }
  };
});
